module.exports = function getResource(label) {
    let resources = { addPromo: 'Add Promo' };
    return resources[label];
};
